export default __webpack_public_path__ + "static/media/standyourground.d9f33484.png";